import { Star } from "lucide-react";

export const Stars = ({ value, size = "w-4 h-4", onChange, testid }) => (
  <div className="flex gap-1" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        disabled={!onChange}
        onClick={() => onChange?.(n)}
        data-testid={onChange ? `rating-star-${n}` : undefined}
        className={onChange ? "transition-transform hover:scale-125" : "cursor-default"}
        aria-label={`${n}`}
      >
        <Star className={`${size} ${n <= value ? "fill-amber-300 text-amber-300" : "text-slate-600"}`} />
      </button>
    ))}
  </div>
);
